// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"importLoaders":1}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-949f0f7a","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./components/LumiApp.vue
// module id = 51
// module chunks = 0